import React, { Component } from 'react'
import classnames from 'classnames/bind'
import Image from 'components/shared/Image'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export default class CirclePicture extends Component {
  static defaultProps = {
    withShadow: false,
  }

  render() {
    const { className, picture, withShadow } = this.props

    return (
      <div className={cx(css.CirclePicture, className, { withShadow })}>
        <Image className={css.picture} forcedRatio={1} {...picture} />
      </div>
    )
  }
}
